import { deleteScopedKey, readScopedString, writeScopedString } from './scopedStorage'

export type ActiveContextSelection = {
  farmId: string
  productionUnitId: string
  lotId: string
}

const STORAGE_KEYS = {
  farmId: 'activeContext:selectedFarmId',
  productionUnitId: 'activeContext:selectedProductionUnitId',
  lotId: 'activeContext:selectedLotId'
} as const

export const loadActiveContextSelection = (): ActiveContextSelection => ({
  farmId: readScopedString(STORAGE_KEYS.farmId) ?? '',
  productionUnitId: readScopedString(STORAGE_KEYS.productionUnitId) ?? '',
  lotId: readScopedString(STORAGE_KEYS.lotId) ?? ''
})

const writeOrClear = (key: string, value: string | null | undefined) => {
  const trimmed = typeof value === 'string' ? value.trim() : ''
  if (!trimmed) {
    deleteScopedKey(key)
    return
  }
  writeScopedString(key, trimmed)
}

export const persistActiveContextSelection = (selection: Partial<ActiveContextSelection>): void => {
  const prev = loadActiveContextSelection()

  if ('farmId' in selection) {
    const nextFarmId = selection.farmId?.trim() ?? ''
    writeOrClear(STORAGE_KEYS.farmId, nextFarmId)

    if (!nextFarmId || (prev.farmId && prev.farmId !== nextFarmId)) {
      deleteScopedKey(STORAGE_KEYS.productionUnitId)
      deleteScopedKey(STORAGE_KEYS.lotId)
    }
  }

  if ('productionUnitId' in selection) {
    const nextUnitId = selection.productionUnitId?.trim() ?? ''
    writeOrClear(STORAGE_KEYS.productionUnitId, nextUnitId)

    if (!nextUnitId || (prev.productionUnitId && prev.productionUnitId !== nextUnitId)) {
      deleteScopedKey(STORAGE_KEYS.lotId)
    }
  }

  if ('lotId' in selection) {
    writeOrClear(STORAGE_KEYS.lotId, selection.lotId)
  }
}
